import React from 'react';
import StringFieldProto from './string-proto.jsx';


export default function renderStringInFormNew(id, props) {
    return <StringFieldProto renderMode="form-new" id={id} {...props} />;
}